const Table = ( { children } ) => {
	return (
		<table className="table table-striped table-hover">
			<tbody>{ children }</tbody>
		</table>
	);
};

export default Table;
